import { CurrentSearch } from './actionTypes';

export const setHotel = (isHotel) => ({
    type: CurrentSearch.SET_HOTEL,
    isHotel,
});

export const addSegment = (segment) => ({
    type: CurrentSearch.ADD_SEGMENT,
    segment,
});

export const deleteSegment = (index) => ({
    type: CurrentSearch.DELETE_SEGMENT,
    index,
});

export const updateSegment = (segment, id) => ({
    type: CurrentSearch.UPDATE_SEGMENT,
    segment,
    id,
});

export const resetSearch = () => ({
    type: CurrentSearch.RESET_SEARCH,
});

export const setAllSearch = (search) => ({
    type: CurrentSearch.SET_ALL_SEARCH,
    search,
});

export const setCabinClass = (cabinClass) => ({
    type: CurrentSearch.SET_CABIN_CLASS,
    cabinClass,
});

export const setChainFilter = (chain) => ({
    type: CurrentSearch.SET_CHAIN_FILTER,
    chain,
});

export const setOnlyDirectFlights = (isDirect) => ({
    type: CurrentSearch.SET_ONLY_DIRECT_FLIGHTS,
    isDirect,
});

export const setPax = (pax) => ({
    type: CurrentSearch.SET_PAX,
    pax,
});

export const setAirlineFilter = (airlineFilter) => ({
    type: CurrentSearch.SET_AIRLINE_FILTER,
    airlineFilter
});

export const setResidentDiscount = (isResident) => ({
    type: CurrentSearch.SET_RESIDENT_DISCOUNT,
    isResident,
});

export const setHotelTripType = (tripType) => ({
    type: CurrentSearch.SET_HOTEL_TRIP_TYPE,
    tripType,
});

export const setTripType = (tripType) => ({
    type: CurrentSearch.SET_TRIP_TYPE,
    tripType,
});

export const showErrors = (showErrors) => ({
    type: CurrentSearch.SET_SHOW_ERRORS,
    showErrors,
});

export const showNonPrimeHotelErrors = (showErrors) => ({
    type: CurrentSearch.SET_NON_PRIME_HOTEL_SHOW_ERRORS,
    showErrors,
});

export const showRoomErrors = (showRoomErrors) => ({
    type: CurrentSearch.SET_SHOW_ROOM_ERRORS,
    showRoomErrors,
});

export const setSeparateStay = (separateStay) => ({
    type: CurrentSearch.SET_SEPARATE_STAY,
    separateStay,
});

export const addRoom = (newRoom) => ({
    type: CurrentSearch.ADD_ROOM,
    newRoom
});

export const updateRoom = (room) => ({
    type: CurrentSearch.UPDATE_ROOM,
    room,
});

export const deleteRoom = (room) => ({
    type: CurrentSearch.DELETE_ROOM,
    room,
});

export const updateNonPrimeHotel = (room) => ({
    type: CurrentSearch.UPDATE_NON_PRIME_HOTEL_ROOM,
    room,
});

export const updateSearcherConfig = (config) => ({
    type: CurrentSearch.UPDATE_CONFIG,
    config
});
